export default "__VITE_ASSET__CsGDqCcr__"